var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isExternal
        ? _c(
            "a",
            {
              staticClass: "hover-noline external",
              attrs: { href: "https://lea.ita-kl.de/dmz/", target: "_blank" }
            },
            [
              _c("div", { staticClass: "featureCardWrapper px-16 py-14" }, [
                _c(
                  "div",
                  { staticClass: "featureIcon mb-12" },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contentWrapper mt-3" }, [
                  _c("h2", { staticClass: "cardHeadline" }, [
                    _vm._v(_vm._s(_vm.headline))
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "cardText mb-6" }, [
                      _vm._v(_vm._s(_vm.featureText))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ctaWrapper" },
                      [
                        _c("p", { staticClass: "cardText cta-text" }, [
                          _vm._v(_vm._s(_vm.ctaText))
                        ]),
                        _vm._v(" "),
                        _c("v-icon", { staticClass: "arrow--red mt-3" }, [
                          _vm._v("mdi-arrow-right")
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        : _c(
            "router-link",
            { staticClass: "hover-noline", attrs: { to: _vm.featureLink } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "featureCardWrapper pa-8 pa-sm-12 pa-md-12 pa-lg-14 pa-xl-16"
                },
                [
                  _c(
                    "div",
                    { staticClass: "featureIcon mb-12" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "contentWrapper mt-3" }, [
                    _c("h2", { staticClass: "cardHeadline" }, [
                      _vm._v(_vm._s(_vm.headline))
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "cardText mb-6" }, [
                        _vm._v(_vm._s(_vm.featureText))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ctaWrapper" },
                        [
                          _c("p", { staticClass: "cardText cta-text" }, [
                            _vm._v(_vm._s(_vm.ctaText))
                          ]),
                          _vm._v(" "),
                          _c("v-icon", { staticClass: "arrow--red mt-3" }, [
                            _vm._v("mdi-arrow-right")
                          ])
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7617a9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7617a9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/landingComponents/MainFeatureCard.vue
// module id = null
// module chunks = 